'use strict';

import React, { Component } from 'react';

import Notif from '../../commonModules/interface/Notif';


class Financial extends Component{
    state = {
        value: "",
        listOfSuperAdmin: [],
        password : "",
        amount: 0.0,
        currency: "EURO",
        currencyList: ["FCFA","EURO","DOLLAR"],
        notif:{
            title:"", 
            type: "", 
            message:"",
            show:false
        },
    }
    notif = (type, msg, title = null) =>{
        this.setState({
            notif: {
                title:title, 
                type, 
                message:msg,
                show:true
            }
        })
    }
    componentDidMount= async () => {
        var urlAdminList = "/admin/list";
        try {
            let req = await fetch(urlAdminList,{
                method:'GET',
                headers: {
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content,
                },
                credentials: 'same-origin',
       
            })
            const res = await req.json()
            console.log({res});
            
            if(!res.errorCode){
                var optionTmp = [];
                optionTmp.push({id: ""})
                try {
                    var data = res; //var data = JSON.parse(result);
                    for (var i = 0; i < data.content.length; i += 1) {
                        optionTmp.push({value: data.content[i].email, id: data.content[i].id})
                    }
                    this.setState({listOfSuperAdmin: optionTmp, value: ""});

                }catch(e){
                        this.notif("danger", "can not get list", "Erreur")
                }
            } else {
                this.notif("danger", "can not get list", "Erreur")
            }
        } catch (error) {
            this.notif("danger", error, "Erreur")
        }
    }
    validate = () =>{
        if (this.state.value === ""){
            this.notif("danger", "Compte ne peut être vide", "Erreur")
            return false
        }        
        if (this.state.amount === 0.0){
            this.notif("danger", "Montant ne peut être nul", "Erreur")
            return false
        }   
        if (this.state.currency === ""){
            this.notif("danger", "Currency ne peut être nul", "Erreur")
            return false
        }          
        if (this.state.password === ""){
            this.notif("danger", "Password ne peut être vide", "Erreur")
            return false
        }
        return true 
    }
    onClickHandle = async (e) => {
        e.preventDefault();

        if(this.validate()){
            let data = {} 
                data.value = this.state.value;
                data.password = this.state.password;
                data.amount = this.state.amount;
                data.currency = this.state.currency;
                try {
                    let req = await fetch('/admin/payment/creditaccount',{
                        method:'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content,
                        },
                        json: true,
                        body: JSON.stringify(data),
                        credentials: 'same-origin',
               
                    });
                    let res = await req.json();
                    console.log({res});
                    
                    if(res.errorCode === "OK"){
                        this.notif("success", "Paiement effectué")
                        this.setState({   value: "",
                        password : "",
                        amount: 0.0,});
                    } else {
                        this.notif("danger", res.content, "Erreur")
                    }
                } catch (error) {
                    console.log(error)
                    this.notif("danger", "error func", "Erreur")
                }
        }
    }
    AmountOnchange = (e) => {
        e.preventDefault();
        this.setState({amount: e.target.value});
    }
    PasswordOnChange= (e) => {
        e.preventDefault();
        this.setState({password: e.target.value});
    }
    DeviseOnchange= (e) => {
        e.preventDefault();
        this.setState({currency: e.target.value});
    }
    onChange= (e) => {
        e.preventDefault();
        var paygoId = e.target.value;
        this.setState({value: paygoId});
    }
    render() {
        console.log('[INFO], render fonction Main PAYG');
        return (
            <div className="container">
                <Notif
                    show={this.state.notif.show} 
                    title={this.state.notif.title} 
                    type={this.state.notif.type} 
                    message={this.state.notif.message} 
                    close={()=> this.setState({
                        notif:{
                            ...this.state.notif,
                            show:false,
                        }
                    })} />

                <div className="card">
                    <div className="card-header">
                        <h1>Créditer compte partenaire
                        </h1>
                    </div>

                    <div id="data-table-basic-header" className="bootgrid-header container-fluid">
                        <div className="row">
                            <div className="col-sm-12 actionBar">
                                <div className="search form-group">
                                    <div className="input-group">
                                        <span className="zmdi icon input-group-addon glyphicon-search"></span>

                                        <select className="search-field form-control" value={this.state.value} onChange={this.onChange}>
                                            {this.state.listOfSuperAdmin.map(function(optionval) {
                                                return <option value={optionval.id}>{optionval.value}</option>;
                                            })
}
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="form-group">Enter un montant
                        <div className="fg-line">
                            <input type="number" className="form-control input-sm" label="Enter montant" placeholder="Enter montant" onChange={this.AmountOnchange} value={this.state.amount}/>
                        </div>
                    </div>
                    <div className="form-group">Enter une devise
                        <div className="fg-line">
                            <select className="search-field form-control" value={this.state.currency} onChange={this.DeviseOnchange}>
                                            {this.state.currencyList.map(function(optionval) {
                                                return <option value={optionval}>{optionval}</option>;
                                            })
}
                                        </select>
                        </div>
                    </div>
                    <div className="form-group">Enter un mot de passe
                        <div className="fg-line">
                            <input type="password" className="form-control input-sm" label="Enter un mot de passe" placeholder="Enter Mot de passe" onChange={this.PasswordOnChange} value={this.state.password}/>
                        </div>
                    </div>
                    {this.state.comment}
                    <div className="btn-demo">
                        <button className="btn btn-success waves-effect" onClick={this.onClickHandle}>Valider Paiement</button>
                    </div>

                </div>
            </div>
        );
    }
};
export default Financial;

//module.exports = Card;
